import { createBrowserRouter, RouterProvider, Outlet } from "react-router";

import 'assets/reset.css'
import { Notice } from "pages/notice";
import { NoticeDetail } from "pages/notice/noticeDetail";
import { useWebview } from "wiz-front-shared/hooks/useWebview";
import { useWebviewMessage } from "hooks/useWebviewMessage";
import { Home } from "pages/home";
import { QNA } from "pages/qna";
import { QNADetail } from "pages/qna/qnaDetail";
import { QNASend } from "pages/qna/qnaSend";
import { Notification } from "pages/notification";
import { FAQ } from "pages/faq";
import { Terms } from "pages/terms";
import { AllTerms } from "pages/allTerms";
import { LocationTerms } from "pages/locationTerms";
import { DeepLinkFallback } from "pages/deepLinkFallback";

function WebviewProvider() {
    const onMessage = useWebviewMessage();
    useWebview({ onMessage });
    return <Outlet />;
}

const router = createBrowserRouter([
    {
        element: <WebviewProvider />,
        children: [
            { path: "/", element: <Home /> },
            { path: "/notice", element: <Notice /> },
            { path: "/notice/detail", element: <NoticeDetail /> },
            { path: "/qna", element: <QNA /> },
            { path: "/qna/detail", element: <QNADetail /> },
            { path: "/qna/send", element: <QNASend /> },
            { path: "/notification", element: <Notification /> },
            { path: "/faq", element: <FAQ /> },
            { path: "/terms", element: <Terms /> },
            { path: "/all-terms", element: <AllTerms /> },
            { path: "/location-terms", element: <LocationTerms /> },
            { path: "/:service/*", element: <DeepLinkFallback /> },
        ]
    }
])

export default function Router() {
    return <RouterProvider router={router} />
}
